module.exports = __webpack_public_path__ + "static/media/Asset2.4a9e99e8.png";